import DashboardScreen from "./dashboard-screen";

export default DashboardScreen